import { iconWrapper, knowledgeCard, svg, textWrapper } from './knowledge-card.module.scss';
import { KnowledgeItem } from './KnowledgeHubData';

export const KnowledgeCard = ({ icon, title, text, color }: KnowledgeItem) => {
    return (
        <div className={knowledgeCard}>
            <div className={iconWrapper} style={{ backgroundColor: color }}>
                <div className={svg}>{icon}</div>
            </div>

            <div className={textWrapper}>
                <h4>{title}</h4>
                <span>{text}</span>
            </div>
        </div>
    );
};
